import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { borderRadius } from "../../../design-system/tokens/borders";
import { rawColors as uiColors } from "@magicbi/ui-library";
import type { PlanTokenTone } from "./PlanToken.types";

/** Inherits font size and line height from the sentence around it. */
export const Button = styled.button<{ $tone: PlanTokenTone }>`
  display: inline;
  margin: 0;
  padding: 0;
  border: 0;
  border-bottom: 1.5px dashed
    ${({ $tone, theme }) => ($tone === "attention" ? rawColors.accent.yellow500 : theme.colors.primary[200])};
  border-radius: 0;
  background: transparent;
  color: ${({ $tone, theme }) => ($tone === "attention" ? uiColors.text.strongEmphasis : theme.colors.primary[500])};
  font: inherit;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background: ${({ theme }) => theme.colors.primary[50]};
  }
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary[500]};
    outline-offset: 2px;
    border-radius: ${borderRadius.sm};
  }
`;
